"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@rradar/core");
var React = require("react");
var SecondaryButton = function (props) {
    return (React.createElement(core_1.Button, { buttonType: "secondary", disabled: props.secondaryDisabled, onClick: function () { return props.secondaryFunction(); } }, props.secondaryText));
};
exports.default = SecondaryButton;
